<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="template-archive-modal-label">
                {{ $root.text(
                    'Archive {template}',
                    { template: $root.text($root.contents.template_title, null, false, 'template_title') },
                    true
                ) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body" :style="($root.hasPermission('templates_delete') ? 'padding-bottom: 200px' : '')">
            <div v-if="sent" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="sent"></div>
                </div>
            </div>
            <div v-else>
                <form>
                    <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                    <p>
                        {{ $root.text(
                            'Archiving the {template} removes it from view for all users.',
                            { template: $root.text($root.contents.template_title, null, false, 'template_title') },
                            true
                        ) }} 
                        {{ $root.text('Users previous versions will no longer be available.', null, true) }}
                    </p>
                    <p>
                        {{ $root.text(
                            'You can make this {template} live again by visiting the archive.',
                            { template: $root.text($root.contents.template_title, null, false, 'template_title') },
                            true
                        ) }} 
                        {{ $root.text('Users will then have access to their previous versions.', null, true) }}
                    </p>
                    <div v-if="$root.hasPermission('templates_delete')" class="form-group">
                        <!--<label for="auto-delete-period">Delete automatically</label>-->
                        <searchable-option-list
                            :key="'auto-delete-period-' + ($root.current_language || 0)"
                            v-model="auto_delete_period"
                            :value="auto_delete_period"
                            :options="getAutoDeleteOptions()"
                            field_id="auto-delete-period"
                            :readonly="sending"
                        ></searchable-option-list>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="!sent" class="modal-footer">
            <span v-if="!sending">
                <span>
                    <button type="button" class="btn btn-primary" @click="onSubmit()">
                        <i class="far fa-archive mr-1"></i> {{ $root.text('Archive now', null, true) }}
                    </button>
                </span>
            </span>
            <span v-else>
                <button type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Archive now', null, true) }}</span>
                </button>
            </span>
            <button type="button" class="btn btn-light ml-2" data-dismiss="modal" :disabled="sending">
                <i class="far fa-times mr-1"></i> {{ $root.text('Cancel', null, true) }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                errors: false,
                sending: false,
                sent: false,
                asset: {
                    title: ''
                },
                list_component: null,
                auto_delete_period: 'never',
                auto_delete_date: null
            }
        },
        mounted () {
            //
        },
        watch: {
            auto_delete_period: function (val) {
                if (!val) {
                    var vm = this;
                    setTimeout(function () {
                        vm.auto_delete_period = 'never';
                    }, 200);
                    return null;
                }
                this.setDate('auto_delete_date', val);
            }
        },
        methods: {
            resetForm: function (asset, listComponent) {
                this.errors = false;
                this.sending = false;
                this.sent = false;
                this.asset = asset;
                this.list_component = listComponent;
                this.auto_delete_period = 'never';
                this.auto_delete_date = null;
            },
            onSubmit: function () {
                this.errors = false;
                this.sending = true;

                /**
                 * Send archive asset request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/resource/'
                    + this.asset.id + '/archive';
                var vm = this;

                axios({
                    method: 'put',
                    url: url,
                    data: { auto_delete_date: this.auto_delete_date },
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.sent = vm.$root.text(
                        '{template} has been archived.',
                        { template: vm.$root.text(vm.$root.contents.template_title, null, false, 'template_title') },
                        true
                    );
                    vm.$root.folders_changed = true;

                    // Deselect asset.
                    let selectedAssets = vm.$root.selected_assets;
                    let itemIndex = -1;
                    selectedAssets.forEach((item, index) => {
                        if (item == this.asset.id) {
                            itemIndex = index;
                        }
                    });
                    if (itemIndex > -1) {
                        selectedAssets.splice(itemIndex, 1);
                    }

                    // Close after 2 seconds automatically.
                    setTimeout(function () {
                        $('#template-archive-modal').modal('hide');
                    }, 2000);

                    // Reload assets.
                    const pages = [
                        'assets',
                        'assets-filtered',
                        'view-collection',
                        'asset-reviews',
                        'shared',
                        'asset-approvals'
                    ];
                    if (pages.indexOf(vm.list_component.component_name) > -1) {
                        vm.list_component.getAssets();

                        return null;
                    }
                    vm.list_component.view_asset = null;
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        $('#template-archive-modal').modal('hide');
                        vm.$root.doLogout();
                    }
                    // Show error.
                    vm.errors = error.response.data.error
                        || vm.$root.text('Something went wrong, please try again', null, true);
                })
                .finally(() =>
                    vm.sending = false
                );
            },
            setDate: function (dateField, value) {
                if (value == 'never') {
                    this[dateField] = null;

                    return null;
                }
                const newDate = new Date();
                if (value == '7d') {
                    newDate.setDate(newDate.getDate() + 7);
                }
                if (value == '1m') {
                    newDate.setMonth(newDate.getMonth() + 1);
                }
                if (value == '3m') {
                    newDate.setMonth(newDate.getMonth() + 3);
                }
                if (value == '6m') {
                    newDate.setMonth(newDate.getMonth() + 6);
                }
                if (value == '12m') {
                    newDate.setMonth(newDate.getMonth() + 12);
                }
                const month = ('0' + (newDate.getMonth() + 1)).slice(-2);
                const day = ('0' + newDate.getDate()).slice(-2);
                this[dateField] = newDate.getFullYear() + '-' + month + '-' + day;
            },
            getAutoDeleteOptions: function () {
                const options = [
                    {
                        id: 'never',
                        name: this.$root.text('Never delete', null, true)
                    },
                    {
                        id: '7d',
                        name: this.$root.text('Delete after 1 week', null, true)
                    },
                    {
                        id: '1m',
                        name: this.$root.text('Delete after 1 month', null, true)
                    },
                    {
                        id: '3m',
                        name: this.$root.text('Delete after 3 months', null, true)
                    },
                    {
                        id: '6m',
                        name: this.$root.text('Delete after 6 months', null, true)
                    },
                    {
                        id: '12m',
                        name: this.$root.text('Delete after 12 months', null, true)
                    }
                ];

                return options;
            }
        }
    }
</script>
